module.exports = __webpack_public_path__ + "img/pc-vi.c5c1804d.jpg";